module.exports = __webpack_public_path__ + "static/media/crane-construction-svgrepo-com.7640331c.svg";